import { useMutation, useQuery } from '@tanstack/react-query';
import { authService } from '../services/auth.service';
import { useAuthStore } from '../store/useAuthStore';
import { useGamificationStore } from '../store/useGamificationStore';

export const useUserQuery = () => {
  const { token, setUser, logout, setLoading } = useAuthStore();
  
  return useQuery({
    queryKey: ['auth', 'me'],
    queryFn: async () => {
      try {
        const data = await authService.me();
        if (data && data.id) {
          setUser(data);
          useGamificationStore.getState().setInitialData(data.xp || 0, data.level || 1);
          return data;
        } else {
          logout();
          return null;
        }
      } catch (error) {
        logout();
        throw error;
      } finally {
        setLoading(false);
      }
    },
    enabled: !!token,
    retry: false,
  });
};

export const useLoginMutation = () => {
  const setAuth = useAuthStore((state) => state.setAuth);
  
  return useMutation({
    mutationFn: authService.login,
    onSuccess: (data) => {
      if (data.token) {
        if (data.user && data.user.idioma) {
          localStorage.setItem('dayflow-lang', data.user.idioma);
        }
        setAuth(data.user, data.token);
        useGamificationStore.getState().setInitialData(data.user.xp || 0, data.user.level || 1);
      }
    },
  });
};

export const useRegistroMutation = () => {
  const setAuth = useAuthStore((state) => state.setAuth);
  
  return useMutation({
    mutationFn: authService.registro,
    onSuccess: (data) => {
      if (data.token) {
        if (data.user && data.user.idioma) {
          localStorage.setItem('dayflow-lang', data.user.idioma);
        }
        setAuth(data.user, data.token);
        useGamificationStore.getState().setInitialData(data.user.xp || 0, data.user.level || 1);
      }
    },
  });
};
